module.exports = __webpack_public_path__ + "static/media/banner2.dc2ebce9.jpg";